import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { addEventListener, Event } from '@ifeng/ui_base';
import { getImage } from '../../../utils/cutImg';
import { formatDateTime, formatVideoDuration } from '../../utils/timeUnit';
import { formatPlayNum, asyncGetPlayNum } from '../../utils/playNumUnit';
import formatThumbnail from '../../utils/formatThumbnail';

import { handleAd } from '../../../utils/utils';
class TopicList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        ad: PropTypes.object,
    };

    state = {
        data: [],
        playNum: new Object(),
    };

    static defaultProps = {};

    event = new Event();

    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            console.log('insertArr', insertArr); // 要插入的数据的索引
            console.log('replaceArr', replaceArr); // 被替换的数据的索引
            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        this.asyncGetPlayNum();

        // 插入广告
        try {
            const { ad } = this.props;

            // event 为传入的 event 事件对象，用于广告方绑定事件
            // insert 为我们自定义的广告插入方法
            // const ad = {
            //     data: {},
            //     preload: '',
            //     callback: (data, event, insert) => {
            //         let box1 = document.createElement('div');

            //         box1.innerHTML = 'qqqqqq';
            //         // insert([], [0], function(dom) {
            //         //     console.log(dom)
            //         //     dom[0].appendChild(box1);
            //         // });
            //         event.on('init', data => {
            //             // data 为我们触发方法时传参值
            //             const insertArr = [];

            //             const replaceArr = [3];

            //             insert(insertArr, replaceArr, dom => {
            //                 console.log(dom);
            //                 dom[3].appendChild(box1);
            //             });
            //         });
            //     },
            // };

            if (this.props.ad) {
                const callback = await handleAd(ad);

                callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
            }
        } catch (e) {
            console.error(e);
        }

        try {
            const data = this.formatStream(this.props.content).slice(0, 3);

            // console.log(data);

            if (data) {
                this.setState(
                    {
                        data,
                    },
                    () => {
                        this.adInit(data); // 数据请求完毕，初始化时触发广告位插入方法，data 为可选的传参值
                    },
                );
            }
        } catch (e) {
            console.error(e);
        }
    }

    adInit = data => {
        try {
            this.event.trigger('init', { data }); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };

    // 获取播放量
    asyncGetPlayNum = async () => {
        const { content } = this.props;

        if (content && Array.prototype.isPrototypeOf(content) && content.length > 0) {
            const playNum = await asyncGetPlayNum(this.props.content);

            // console.log(playNum);
            this.setState({
                playNum,
            });
        }
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    formatTitle(t) {
        let newTitle = '';

        if (t.length > 40) {
            newTitle = `${t.substr(0, 40)}...`;
        } else {
            newTitle = t;
        }

        return newTitle;
    }

    // 去重
    formatStream(data) {
        if (!Array.prototype.isPrototypeOf(data) || data.length < 0) {
            return [];
        }
        const newArr = new Array();

        data.filter(each => {
            let flag = true;

            newArr.forEach(item => {
                if (each.guid === item.guid) {
                    flag = false;
                }
            });

            return flag;
        });

        return data;
    }

    // 处理跳转链接
    formatLink(item) {
        let url = '';

        if (item.base62Id) {
            url = `//v.ifeng.com/c/${item.base62Id}`;
        } else if (item.url) {
            url = item.url;
        } else {
            url = '';
        }

        return url;
    }

    render() {
        const { content } = this.props;
        const { playNum, data } = this.state;
        const listItem = (item, index) => {
            if (item.type === 'ad') {
                return <div className={styles.listItem} ref={item.ref} key={index} />;
            } else {
                return (
                    item &&
                    Object.keys(item).length > 0 && (
                        <div className={styles.listitem} key={index}>
                            <div className={styles.vPic}>
                                <a href={this.formatLink(item)} target="_blank">
                                    <img
                                        src={item.posterUrl ? getImage(item.posterUrl, 198, 112) : ''}
                                        alt={item.title}
                                    />
                                    <i />
                                    <div className={styles.mask} />
                                </a>
                            </div>
                            <div className={styles.vinfo}>
                                <div className={styles.title}>
                                    <a href={this.formatLink(item)} target="_blank">
                                        {this.formatTitle(item.title)}
                                    </a>
                                </div>
                                <div className={styles.mediaImg}>
                                    {item.posterUrl ? (
                                        <img src={getImage(item.posterUrl, 25, 25)} alt="" />
                                    ) : (
                                        <img src="http://p1.ifengimg.com/a/2016/1129/25_25.jpg" alt="" />
                                    )}
                                </div>
                                <div className={styles.mediaName}>{item.wemediaEAccountName}</div>
                                <div className={styles.vlistinfo}>
                                    <span className={styles.date}>{item.newsTime}</span>
                                    <span className={styles.time}>{formatVideoDuration(item.duration)}</span>
                                    <span className={styles.playNum}>{playNum ? playNum[item.guid] : ''}</span>
                                </div>
                            </div>
                        </div>
                    )
                );
            }
        };

        // console.log(data);

        return (
            <div className={styles.topiclist}>
                {content && Array.prototype.isPrototypeOf(content) && content.length > 0
                    ? data.map((item, index) => {
                          return listItem(item, index);
                      })
                    : null}
            </div>
        );
    }
}

export default TopicList;
